module.exports = __webpack_public_path__ + "img/personimg1.5085084e.png";